import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit, AfterViewInit, ElementRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from '../Shared/toaster.service';
import { SELECT_BLACKLIST_WHITELIST_CUSTOMERS } from '../Models/Report/SELECT_BLACKLIST_WHITELIST_CUSTOMERS';
import { DeviceService } from '../ApiServices/device.service';
import { MasterRolePermission } from '../Models/master-role-permission';
import { ReportApiService } from '../ApiServices/report-api.service';
import { IdList, ReportParameters } from '../Models/report-parameters';

import * as $ from 'jquery';
import { exit } from 'node:process';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterParkingDeviceAction } from '../Models/master-device-action';

@Component({
  selector: 'app-black-list-white-list',
  templateUrl: './black-list-white-list.component.html',
  styleUrls: ['./black-list-white-list.component.css']
})
export class BlackListWhiteListComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef, private formbuilder: FormBuilder, private router: Router, private toasterService: ToasterService, private reportApiService: ReportApiService) { }

  SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST: SELECT_BLACKLIST_WHITELIST_CUSTOMERS[] = [];

  SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST_FORM: FormGroup;
  reportParameters: ReportParameters;

  ngOnInit(): void {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    } else {
      if (sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(MasterRolePermission.ViewBlackListWhiteList.rolePermission) < 0) {
        alert("Unauthorised access");
        this.router.navigateByUrl('/index');
        return;
      } else {
        $('.exampleCheck').on('change', function () {
          $('.exampleCheck').prop('checked', false);
          $(this).prop('checked', true);
        });
        this.reportParameters = new ReportParameters();
        this.reportParameters.fromdate = '2';
        this.INIT_SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST();
        this.SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST_FORM_SUBMIT();
      }
    }
  }

  INIT_SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST() {
    this.SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST_FORM = this.formbuilder.group({
      exampleCheckAll: true,
      exampleCheckActive: false,
      exampleCheckInactive: false
    });

  }

  updateValue(value: string) {
    this.reportParameters.fromdate = value;
  }

  SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST_FORM_SUBMIT() {
    this.SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST = [];
    this.reportApiService.SELECT_BLACKLIST_WHITELIST_CUSTOMERS(this.reportParameters).subscribe(w => {
      this.SELECT_BLACKLIST_WHITELIST_CUSTOMERS_LIST = w;
    })
  }

}
